/** Tabs of the live-course cockpit. Extended as features are folded in. */
export type CursoTab =
  | 'resumen'
  | 'modules'
  | 'syllabus'
  | 'cronograma'
  | 'asistencia'
  | 'biblioteca'
  | 'asignaciones'
  | 'notas';

export const CURSO_TABS: readonly CursoTab[] = [
  'resumen',
  'modules',
  'syllabus',
  'cronograma',
  'asistencia',
  'biblioteca',
  'asignaciones',
  'notas',
];

/** Quien puede leer el libro de notas, como lo exige `getSectionGradebook`:
 *  administración, registro, la plataforma, el decano (SOLO LECTURA, decisión
 *  de Ricardo, PR 3A) o un docente (el servidor mira además que enseñe en ESA
 *  sección). El mentor no: el servidor le niega el libro. */
export const GRADEBOOK_READER_ROLES = [
  'platformAdmin',
  'tenantAdmin',
  'registrar',
  'academicDean',
  'faculty',
];

/** Quien ESCRIBE en el libro: pone notas, guarda avance, cierra el acta. Sin
 *  el decano: lee, no califica (como en Calificar). */
export const GRADEBOOK_WRITER_ROLES = ['platformAdmin', 'tenantAdmin', 'registrar', 'faculty'];

/** Las pestañas que se OFRECEN y se ACEPTAN en la URL.
 *
 *  Notas, también con `graduation_audit` (H1): antes se escondía, como si el
 *  seminario no tuviera libro de notas. Ahora el libro PROPONE la nota final
 *  al ACTA, que convive con el expediente importado.
 *
 *  PERO NO A QUIEN EL SERVIDOR SE LA NIEGA (PM, PR 3A): el mentor entra a
 *  /curso y la pestaña le mostraba un error. Se esconde por cargo, no se
 *  muestra vacía. El decano sí la ve, en solo lectura. La pantalla /curso entera depende del módulo «Aula
 *  virtual» (ModuleGate); el acta está además fuera de /curso, en Secciones. */
export function cursoTabs(roles: readonly string[]): readonly CursoTab[] {
  const leeNotas = roles.some((r) => GRADEBOOK_READER_ROLES.includes(r));
  return leeNotas ? CURSO_TABS : CURSO_TABS.filter((tab) => tab !== 'notas');
}

/** La pestaña activa según `?tab=`: una que no se ofrece cae al resumen. */
export function resolveCursoTab(param: string | null, tabs: readonly CursoTab[]): CursoTab {
  return tabs.includes(param as CursoTab) ? (param as CursoTab) : 'resumen';
}
